<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <!-- LOADING OVERLAY -->
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Prendre un rendez-vous</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-stepper v-model="e6" vertical>
          <v-stepper-step :complete="e6 > 1" step="1">
            Choisir la date du RDV
            <small>Choisir la date et heure qui vous convient</small>
          </v-stepper-step>
          <!-- Stepper 1 -->
          <v-stepper-content step="1">
            <!-- Step 1 Form Date & Time -->
            <v-form v-model="isValidGInfo">
              <v-container>
                <v-row justify="center">
                  <v-col cols="12" md="8">
                    <v-date-picker
                      first-day-of-week="1"
                      :allowed-dates="allowedDates"
                      color="success"
                      no-title
                      locale="fr"
                      v-model="rdvDate"
                    />
                    <v-time-picker
                      locale="fr"
                      format="24hr"
                      no-title
                      v-model="rdvTime"
                      color="green"
                      header-color="primary"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-btn color="primary" @click="next(2)">Continuer</v-btn>
          </v-stepper-content>
          <!-- Step 2 Objectifs -->
          <v-stepper-step :complete="e6 > 2" step="2">
            Objectif
            <small>Présisez votre objectif</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <ObjectifCards @onSelected="selectObj" />
            <v-btn color="primary" @click="next(3)">Continue</v-btn>
            <v-btn text @click="e6 = 1">Revenir</v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 3" step="3">
            Paramétres
            <small>Aidez votre coach pour vous connaitre</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <!-- Step 3 body info -->
            <v-row>
              <v-col cols="12" md="6">
                <v-subheader class="pl-0">Votre taille</v-subheader>
                <v-slider
                  v-model="user.height"
                  max="218"
                  min="100"
                  thumb-size="24"
                  prepend-icon="$vuetify.measure"
                  thumb-label="always"
                ></v-slider>
              </v-col>
              <v-col cols="12" md="6">
                <v-subheader class="pl-0">Votre poids</v-subheader>
                <v-slider
                  v-model="user.weight"
                  max="300"
                  min="30"
                  thumb-size="24"
                  prepend-icon="$vuetify.scale"
                  thumb-label="always"
                ></v-slider>
              </v-col>
            </v-row>

            <v-btn color="primary" @click="next(4)">Continue</v-btn>
            <v-btn text @click="e6 = 2">Revenir</v-btn>
          </v-stepper-content>

          <v-stepper-step step="4">
            Contact
            <small>Comment nous pouvons vous contacter?</small>
          </v-stepper-step>
          <v-stepper-content step="4">
            <!-- Step 4 Form Contact -->
            <v-form v-model="isValidContact">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Numéro de telephone"
                      v-model="user.phone"
                      :rules="phoneRules"
                      prefix="+216 - "
                      prepend-icon="mdi-phone"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          v-model="user.mail"
                          readonly
                          :rules="emailRules"
                          label="E-mail"
                          prepend-icon="mdi-email"
                          required
                        ></v-text-field>
                      </template>
                      Vous ne pouvez pas changer votre adresse
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-btn color="primary" @click="onSendForm">Envoyer</v-btn>
            <v-btn text @click="e6 = 3">Revenir</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import ObjectifCards from "@/components/dashboard/ObjectifCards";
import moment from "moment";

export default {
  props: ["dialog", "coachId", "offDays"],
  components: {
    ObjectifCards,
  },
  data() {
    return {
      rdvDate: new Date().toISOString().substr(0, 10),
      rdvTime: null,
      isValidGInfo: true,
      isValidFitInfo: true,
      isValidContact: false,
      selectedObjectif: null,
      height: 120,
      weight: 40,
      phoneRules: [
        (v) => !!v || "Nurémo est requis",
        (v) => v.length < 8 || "Numéro 8 chiffres",
        (v) => v.length > 8 || "Numéro 8 chiffres",
      ],
      items: [
        "Ariana",
        "Béja",
        "Ben Arous",
        "Bizerte",
        "Gabès",
        "Gafsa",
        "Jendouba",
        "Kairouan",
        "Kasserine",
        "Kebili",
        "Kef",
        "Mahdia",
        "Manouba",
        "Medenine",
        "Monastir",
        "Nabeul",
        "Sfax",
        "Sidi Bouzid",
        "Siliana",
        "Sousse",
        "Tataouine",
        "Tozeur",
        "Tunis",
        "Zaghouan",
      ],
      age: 0,
      ageRules: [(v) => v > 0 || "L'age doit être valide"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail est requis",
        (v) => /.+@.+/.test(v) || "E-mail doit être valide",
      ],
      notifications: false,
      sound: true,
      widgets: false,
      e6: 1,
    };
  },
  computed: {
    ...mapGetters(["user", "loading"]),
  },
  methods: {
    next(v) {
      if (this.checkForm(v)) this.e6 = v;
    },
    allowedDates: function (val) {
      return this.offDays.includes(new Date(val).getDay());
    },
    checkForm(v) {
      switch (v) {
        case 2:
          return this.isValidGInfo;
          break;
        case 3:
          return this.selectedObjectif !== null;
          break;
        case 4:
          return this.isValidFitInfo;
          break;
        // case 4:
        //   return this.isValidContact;
        //   break;
      }
    },
    close() {
      this.$emit("close-dialog");
    },
    selectObj(v) {
      this.selectedObjectif = v;
    },
    ...mapActions({
      onBookCoach: "bookCoach",
    }),
    async onSendForm() {
      await this.onBookCoach({
        user: this.user,
        coachId: this.coachId,
        objectif: this.selectedObjectif,
      });
      this.close();
    },
  },
};
</script>